import React from 'react'
import { useDispatch, useSelector } from 'react-redux';

import { AutoComplete, Empty, Input,Spin } from "antd";
import Styles from './NewEditorStyles.module.css'
import AnsweredByOtherNameInfo from './AnsweredByOtherNameInfo';
import AnsweredByOtherAnswer from './AnsweredByOtherAnswer';

const containerStyle = {
  border: "1px solid #E0E2E6",
  borderRadius: "16px",
  background: "#FFFFFF",
  boxShadow: "0px 4px 16px 0px #1018280F",
  padding: "24px 36px 24px 36px",
  minHeight: "100px",
  marginBottom: '24px'
  
};
export default function NewOtherExpertAnswers() {


  const editorData = useSelector(state=>state.editor);
  const dispatch = useDispatch();
  // const {} = bindActionCreators(Actions, dispatch);
  const noDataAvailable = () => {
    return (
      <div className="trendingfilterbar" style={{ textAlign: "center" }}>
       <Empty/>
      </div>
    );
  };
  // console.log("value", editorData.anotherExpertAnswer.answers )
  let uuid=[];
  const uuidVal= editorData.anotherExpertAnswer.answers?.map((item)=>{
    // console.log('ids',item)
    uuid.push(item?.expertUuid)
    return item?.expertUuid
    // return uuid
  });
  const spinner=editorData.anotherExpertAnswer.answers!==undefined&&!editorData.ratingBool;
  // console.log("another spinner", editorData?.anotherExpertAnswer?.answers && editorData?.anotherExpertAnswer?.answers?.length ===0)
  return (
    <div>
         <Spin size="large" spinning={!spinner} style={{ display: 'flex' ,marginTop:"5%"}} >
             {
             editorData?.anotherExpertAnswer?.answers && editorData?.anotherExpertAnswer?.answers.length > 0  ? editorData?.anotherExpertAnswer?.answers.map((qas,index)=>{
                  return (
                    <div style={{marginTop:"15px"}}>
                   
                     <div style={containerStyle} key={qas?.answerUuid}>
                       <AnsweredByOtherNameInfo data={qas} uuidVal={uuidVal} />
                        <AnsweredByOtherAnswer data={qas}/>
                        {/* {editorData.anotherExpertAnswer.answers.length - 1 !== index && <p className={Styles.onSelectedtab} style={{ marginBottom: '10px', marginTop: '15px' }}></p>} */}
                       </div>
                
                      </div>
                  )
              }):  editorData?.anotherExpertAnswer?.answers && editorData?.anotherExpertAnswer?.answers?.length ===0?noDataAvailable():null
          }
    </Spin>
     </div>

    // </div>
  )
}